import React from 'react';

import { Button, ButtonProps } from '../../button/Button';

export const ToolbarButton = (props: Omit<ButtonProps<{}>, 'size'>) => {
  return <Button {...props} size="lg" />;
};
